import { Component } from "@angular/core";

@Component({
  selector: "cla-coverage",
  templateUrl: "./coverage.component.html",
  standalone: false,
})
export class CLACoverageComponent {}
